import React, { useState } from "react";
import "./modeSelector.css";
import Terminal from "../terminal/Terminal";
import Chatbot from "../chatbot/Chatbot";
import MacOSWindow from "../MacOSWindow/MacOSWindow";

const ModeSelector = ({ uiComponent }) => {
  const [activeTab, setActiveTab] = useState("ui");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <MacOSWindow activeTab={activeTab} onTabChange={handleTabChange}>
      <div className="ui-wrapper">
        {activeTab === "ui" ? (
          uiComponent
        ) : activeTab === "terminal" ? (
          <Terminal onSwitchMode={handleTabChange} />
        ) : (
          <Chatbot onSwitchMode={handleTabChange} />
        )}
      </div>
    </MacOSWindow>
  );
};

export default ModeSelector;
